import React, { FC } from 'react';
import MuxPlayer from '@mux/mux-player-react';
import { THEME_COLORS } from '@/core/constants';
import { TypeUnsignedMuxAudioAsset } from '@/components/courses/CourseVideo/utils';
import { ANONYMOUS } from '@/utils/dataLayer';
import {
  ASSET_TYPES,
  generateMuxPlaybackEvents,
} from '@/utils/videoPlayerHelpers';

const CourseSongPreview: FC<TypeUnsignedMuxAudioAsset> = ({
  songTitle,
  muxAudioUpload,
}) => {
  const eventProps = generateMuxPlaybackEvents({
    title: songTitle,
    duration: muxAudioUpload.duration,
    isSigned: false,
    type: ASSET_TYPES.AUDIO,
    viewerId: ANONYMOUS,
  });

  return (
    <div
      className="mt-4 flex flex-col gap-3"
      data-testid="course-song-preview-container"
    >
      <p className="text-left">{songTitle}</p>
      <MuxPlayer
        audio
        streamType="on-demand"
        playbackId={muxAudioUpload.playbackId}
        primaryColor={THEME_COLORS.primary}
        secondaryColor={THEME_COLORS.white}
        metadata={{
          video_id: muxAudioUpload.playbackId,
          video_title: songTitle,
          viewer_user_id: ANONYMOUS,
          env_key: process.env.NEXT_PUBLIC_MUX_ENV_KEY,
          player_name: 'Web Course Preview Song Player',
          // If updates made to the player, update me with either a minor or major version bump
          player_version: '1.0',
          video_content_type: 'trailer',
          video_producer: 'Lovevery',
        }}
        {...eventProps}
      />
    </div>
  );
};

export default React.memo(CourseSongPreview);
